import { BiUpArrow, BiSolidUpArrow, BiDownArrow, BiSolidDownArrow } from 'react-icons/bi';
import { Box } from '@chakra-ui/react';

interface SortIconProps {
  isActive: boolean;
  direction: 'asc' | 'desc';
  iconSize?: number;
}

export const SortIcon = ({ isActive, direction, iconSize = 10 }: SortIconProps) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {isActive && direction === 'asc' ? (
        <BiSolidUpArrow size={iconSize} />
      ) : (
        <BiUpArrow size={iconSize} />
      )}
      {isActive && direction === 'desc' ? (
        <BiSolidDownArrow size={iconSize} />
      ) : (
        <BiDownArrow size={iconSize} />
      )}
    </Box>
  );
};
